var exports = {
  "k": "xfb577c5e--819aff--container",
  "I": "xfb577c5e--819aff--logo_img",
};

module.exports = exports;
